module.exports = __webpack_public_path__ + "img/lost.800685de.png";